import React from 'react';
import { Shield, Plus, Info } from 'lucide-react';

function RolesList({ rolesInfo, selectedRole, setSelectedRole, getRoleCount }) {
  const roles = Object.values(rolesInfo);

  return (
    <div className="flex flex-col h-full bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
      
      {/* Header */}
      <div className="p-5 border-b border-slate-100 flex items-center justify-between shrink-0">
        <h3 className="font-bold text-slate-900 text-lg">Rôles disponibles</h3>
        <button className="flex items-center text-sm font-bold text-slate-700 hover:text-slate-900 transition-colors px-2">
          <Plus className="w-4 h-4 mr-1.5" />
          Ajouter un rôle
        </button>
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {roles.map(role => {
          const isSelected = selectedRole?.id === role.id;
          
          return (
            <div 
              key={role.id}
              onClick={() => setSelectedRole(role)}
              className={`p-4 rounded-xl cursor-pointer border transition-all flex items-center gap-4 ${
                isSelected 
                  ? 'bg-emerald-50/50 border-emerald-200 shadow-sm' 
                  : 'bg-white border-slate-100 hover:border-slate-300 hover:bg-slate-50'
              }`}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${
                `bg-${role.color}-50 text-${role.color}-500`
              }`}>
                <Shield className="w-6 h-6" />
              </div>
              <div className="flex-1 min-w-0 pr-2">
                <h4 className={`text-base font-bold truncate ${isSelected ? 'text-slate-900' : 'text-slate-800'}`}>
                  {role.name}
                </h4>
                <p className="text-xs text-slate-500 leading-tight mt-1">{role.description}</p>
              </div>
              
              {/* Badge for count */}
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${
                isSelected ? 'bg-white text-emerald-600 border border-emerald-500' : 'bg-white text-slate-600 border border-slate-200'
              }`}>
                {getRoleCount(role.id)}
              </div>
            </div>
          );
        })}
      </div>

      {/* About Box */}
      <div className="m-4 p-4 bg-slate-50 border border-slate-100 rounded-xl shrink-0">
        <div className="flex gap-3">
          <Info className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
          <div>
            <h5 className="text-sm font-bold text-slate-900 mb-1">À propos des rôles</h5>
            <p className="text-xs text-slate-600 leading-relaxed">
              Les rôles permettent de définir les niveaux d'accès des utilisateurs selon leurs responsabilité.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}

export default RolesList;
